// Never persist the reset password. This short-lived value supports creating the optional
// same-email personal account during the same browser journey.
let pending: { invitationId: string; memberId: string; password: string; expires: number } | undefined
let expiryTimer: ReturnType<typeof setTimeout> | undefined

export function rememberResetPassword(invitationId: string, memberId: string, password: string) {
  clearResetPassword()
  pending = { invitationId, memberId, password, expires: Date.now() + 15 * 60 * 1000 }
  expiryTimer = setTimeout(clearResetPassword, 15 * 60 * 1000)
}

export function takeResetPassword(invitationId: string, memberId: string): string | undefined {
  const value = pending && pending.invitationId === invitationId && pending.memberId === memberId && pending.expires > Date.now() ? pending.password : undefined
  clearResetPassword()
  return value
}

export function clearResetPassword() {
  if (expiryTimer) clearTimeout(expiryTimer)
  expiryTimer = undefined
  pending = undefined
}
